/**
 * This is import script.js file
 */
import ActionsDetail from '@/components/actions-detail';
import moment from 'moment';

export default {
  name: 'DayEndClosing',
  components: {
    ActionsDetail
  },
  /**
   * @override
   */
  data() {
    return {
      percentage: 0,
      inProgress: [],
      items: []
    };
  },

  props: {
    data: {
      type: Array,
      required: true
    }
  },

  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(data) {
        this.updateItems(data);
      }
    }
  },

  computed: {
    uuid() {
      return this.data ? this.data.uuid : null;
    },
    file() {
      return this.data ? this.data.file : null;
    },
    filename() {
      return this.data ? this.data.filename : null;
    },
    filetype() {
      return this.data ? this.data.filetype : null;
    },
    filesize() {
      return this.data ? this.data.filesize / 1024 : null;
    },
    status() {
      return this.data ? this.data.status : null;
    },
    createdOn() {
      return this.data ? this.data.created_on : null;
    },
    fields() {
      return [
        {
          key: 'status',
          label: ' '
        },
        {
          key: 'filetype',
          label: 'Fichero',
          formatter: value => this.$t(`importer.file_types.${value}`)
        },
        {
          key: 'created_on',
          label: 'Fecha'
        },
        {
          key: 'filerecords',
          label: 'Registros'
        },
        {
          key: 'errors',
          label: 'Erróneas'
        }
      ];
    }
  },

  methods: {
    updateItems(data) {
      const inProgress = [];
      const filetypes = JSON.parse(localStorage.getItem('BOPLFT'));
      const dayEndClosingFiles = Object.keys(filetypes.names).map((key, index) => ({
        key: key,
        order: index + 1
      }));
      this.items = dayEndClosingFiles.map(x => {
        const uploads = data.filter(u => u.filetype === x.key);
        x.filetype = x.key;
        x.uploads = uploads;
        x.status = 'MISSING';
        if (x.uploads && x.uploads.length > 0) {
          x.uploads.sort((b, a) => {
            return moment(a.created_on).diff(moment(b.created_on));
          });
          const last = x.uploads[0];
          x.status = last.status;
          x.created_on = last.created_on;
          x.filename = last.filename;
          x.filerecords = last.filerecords;
          x.errors = last.errors;
          x.filesize = last.filesize;
          x.uuid = last.uuid;
          if (x.status === 'IN_PROGRESS') {
            inProgress.push(x.filetype);
          }
        }
        return x;
      });
      this.$emit('in-progress', inProgress);
    },
    downloadErrorsLog(row) {
      this.$importService
        .downloadUploadErrorsLogByUuid(row.item.uuid)
        .then(response => {
          const a = document.createElement('a');
          a.href = `data:text/csv;charset=utf-8,${encodeURI(response.data)}`;
          a.target = '_blank';
          a.download = `${row.item.filetype}_errors-log.csv`;
          a.click();
        })
        .catch(error => console.error(error));
    }
  }
};
